/* eslint-disable react-hooks/exhaustive-deps */
import * as THREE from 'three'
import React, { useMemo } from 'react'

import { const_var, params } from '../../../../../../../../redux/reducers/reducer';

import { delModel, extrudeSettings, wainscotTrimModel } from '../../../../../../../../utils/Functions';
import { CSG } from '../../../../../../../../assets/libs/csg-lib';
import { MaterialWainScotTrimNew } from '../../../../../../CustomMaterial';

const TrimModel = () => {    
    const textureObj = useMemo(() => {
        const texture = const_var.wallTextureObj?.[params.wallTexture]?.clone();
        const metalTexture = const_var.wallTextureObj?.["vertical"]?.clone();
        const lightTexture = const_var.wallTextureObj?.["vertical_light"]?.clone();
        const wainscotTexture = const_var.wallTextureObj?.[params.wainscotTexture]?.clone();
        
        if(metalTexture){
            if (params.wallOrientation == "vertical") metalTexture.rotation = 0;
            else metalTexture.rotation = Math.PI/-2;
        }
        if(lightTexture) lightTexture.rotation = metalTexture.rotation;
        if(texture && const_var.selSidingOption == "metal") texture.rotation = metalTexture.rotation
        if(wainscotTexture && (params.wainscotTexture == "none" || params.wainscotTexture == "vertical")) wainscotTexture.rotation = metalTexture.rotation

        return {"texture":texture,"wainscotTexture" : wainscotTexture,"metalTexture":metalTexture,"lightTexture":lightTexture};
    }, [params.p_v_w, params.wallTexture, const_var.wallTextureObj, const_var.selSidingOption, params.wallOrientation,params.wainscotTexture]);

    const railWidth = 0.2

    const legDistance = useMemo(() => {
        return (const_var.DistanceArr.length>0 && const_var.DistanceArr[params.p_b_t][params.p_r_s]!=undefined) ? const_var.DistanceArr[params.p_b_t][params.p_r_s] : 5
    }, [const_var.DistanceArr, params.p_b_t, params.p_r_s,params.fourth_center_cost,const_var.DistanceArr.length>0 && const_var.DistanceArr[params.p_b_t][params.p_r_s]!=undefined && const_var.DistanceArr[params.p_b_t][params.p_r_s]])

    let offset;

    if(params.leanF_p_d % legDistance === 0) offset = 0.15;
    else offset = 0;

    const trimOffset = useMemo(() => {
        if(params.frontLeanStoragePosition > 0 && params.frontLeanStoragePosition !== params.leanF_p_d - parseInt(params.add_storage_front) - railWidth) return railWidth;
        else return 0;
    }, [params.frontLeanStoragePosition, params.leanF_p_d, params.add_storage_front])
    
    const wainscotTrimSideModelObj = useMemo(() => {
        let lengthOffset;
        if(params.frontLeanStoragePosition === params.leanF_p_d - parseInt(params.add_storage_front) - railWidth) lengthOffset = 0.12;
        else lengthOffset = 0;

        /**********************cutting hole using CSG for side Wainscot-trim************************/

        const meshWainscotTrimModel = new THREE.Mesh(new THREE.ExtrudeGeometry(wainscotTrimModel(0.14, 0.17), extrudeSettings(parseInt(params.add_storage_front) + lengthOffset + offset + trimOffset)), new THREE.MeshStandardMaterial({color: 'red'}))
        const meshDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('frontLeanSide', 'wall'), extrudeSettings(1)) , new THREE.MeshStandardMaterial({color: 'blue'}))
    
        const meshWainscotTrimModel_Temp = meshWainscotTrimModel.clone();
        meshWainscotTrimModel_Temp.rotation.y = Math.PI/-2
        meshWainscotTrimModel_Temp.position.set(-params.leanF_p_d / 2 + parseInt(params.add_storage_front) + lengthOffset + offset + trimOffset, 3 , 0.15);
        meshWainscotTrimModel_Temp.updateMatrixWorld()

        const meshDelModel_Temp = meshDelModel.clone();
        meshDelModel_Temp.position.set(-params.leanF_p_pos - params.frontLeanStoragePosition, 0, -0.5);
        meshDelModel_Temp.updateMatrixWorld()
       
        const meshWainscotTrimModel_CSG = CSG.fromMesh(meshWainscotTrimModel_Temp);     
        const meshDelModel_CSG = CSG.fromMesh(meshDelModel_Temp);
    
        const WainscotTrimModel_CSG = meshWainscotTrimModel_CSG.subtract(meshDelModel_CSG);
        const CSGWainscotTrimSideModel = CSG.toMesh(WainscotTrimModel_CSG, new THREE.Matrix4())

        return CSGWainscotTrimSideModel.geometry;
        
    }, [params.leanF_p_pos, params.leanF_p_d, params.leanF_p_h, trimOffset, offset, params.frontLeanStoragePosition, params.p_b_c_b_f_l, params.add_storage_front, params.add_right_front_lean_porch, params.add_left_front_lean_porch, const_var.newDoorsArray])

    return (
        <group position={[0, 0, params.p_d / 2 + params.leanF_p_w + 0.005]}>
            {params.p_w_c_n === true &&
                <mesh name="wainscotTrim" geometry={wainscotTrimSideModelObj} >
                    <MaterialWainScotTrimNew   visibleSection={"frontLean"}/>
                </mesh>
            }
        </group>
    )
}

export default TrimModel